import { IconLoader2 } from '@tabler/icons-react';
import { TranscriptViewToggleProps } from '@/types';
import { Button } from '../ui/button';
import { TranscriptsView } from '@/enums';
import useTranslation from '@/hooks/useTranslation';

function TranscriptsViewToggle({
  activeView,
  onViewChange,
  completedCount,
  incompleteCount,
  isLoading = false,
  showIncompleteToggle = true,
}: TranscriptViewToggleProps) {
  const { lang } = useTranslation();

  // Only show loader on the active tab
  const isCompletedLoading = isLoading && activeView === TranscriptsView.COMPLETED;
  const isIncompleteLoading = isLoading && activeView === TranscriptsView.INCOMPLETE;

  return (
    <div className="flex gap-2">
      <Button
        variant={activeView === TranscriptsView.COMPLETED ? 'default' : 'outline'}
        onClick={() => onViewChange(TranscriptsView.COMPLETED)}
        disabled={isLoading}
      >
        <span className="capitalize mr-1">{lang.get(`msg.${TranscriptsView.COMPLETED}`)}</span>
        {isCompletedLoading ? (
          <IconLoader2 className="inline h-4 w-4 animate-spin" />
        ) : (
          `(${completedCount})`
        )}
      </Button>
      {showIncompleteToggle && (
        <Button
          variant={activeView === TranscriptsView.INCOMPLETE ? 'default' : 'outline'}
          onClick={() => onViewChange(TranscriptsView.INCOMPLETE)}
          disabled={isLoading}
        >
          <span className="capitalize mr-1">{lang.get(`msg.${TranscriptsView.INCOMPLETE}`)}</span>
          {isIncompleteLoading ? (
            <IconLoader2 className="inline h-4 w-4 animate-spin" />
          ) : (
            `(${incompleteCount})`
          )}
        </Button>
      )}
    </div>
  );
}

export default TranscriptsViewToggle;
